<div class="app-container">
    <div class="app-grid">
        @for(applicant of recentlyViewedApplicants; track applicant.applicantId) {
        <div class="applicant" (click)="selectRecentlyViewed(applicant)">
            <div class="app-status" [ngClass]="getStatusClass(applicant.userState)"></div>
            <div class="app-image">
                @if(applicant.bookmarkId) {
                <div class="app-bookmark">
                    <i class="fa-solid fa-bookmark"></i>
                </div>
                }
                <app-cf-profile [urlOrInitials]="applicant.profileImageUri ?? ''" [width]="44"
                    [height]="44"></app-cf-profile>
            </div>
            <div class="app-name">{{ applicant.firstName }} {{ applicant.lastName }}</div>
            @if(showEmail) {
            <div class="app-email">{{ applicant.email }}</div>
            }

        </div>
        }
    </div>
</div>